var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecipesGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_725_113151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.765453 19.5194C0.553727 19.3077 0.445149 19.0525 0.445149 18.7648C0.445149 18.4771 0.553727 18.2273 0.765453 18.0102L11.4875 7.28815C11.102 6.35981 11.0423 5.41519 11.3083 4.46513C11.5744 3.51508 12.101 2.64103 12.8881 1.84298C13.6808 1.06665 14.7014 0.54005 15.9555 0.263177C17.2041 -0.0136956 18.241 0.263177 19.0662 1.08294C19.9077 1.92442 20.1791 2.96133 19.886 4.19369C19.5928 5.42604 19.0282 6.46839 18.1976 7.31529C17.4864 8.05362 16.6612 8.56394 15.722 8.84624C14.7828 9.12854 13.8816 9.1014 13.0239 8.77024L11.4984 10.2958L19.2128 18.0102C19.4245 18.2219 19.5331 18.4771 19.5331 18.7648C19.5331 19.0525 19.4245 19.3023 19.2128 19.5194C19.0011 19.7311 18.7459 19.8397 18.4582 19.8397C18.1704 19.8397 17.9207 19.7311 17.7036 19.5194L9.98912 11.805L2.27468 19.5194C2.06296 19.7311 1.8078 19.8397 1.52007 19.8397C1.23234 19.8397 0.982608 19.7311 0.765453 19.5194ZM4.66882 10.4858L1.51464 7.31529C0.597158 6.40867 0.0977008 5.38804 0.0162676 4.24798C-0.0651657 3.10248 0.20085 2.02756 0.814313 1.01779C0.97718 0.773492 1.21062 0.643199 1.50921 0.621484C1.8078 0.605197 2.06296 0.702917 2.28554 0.925501L8.26274 6.88641L4.66339 10.4858H4.66882Z",
    fill: "#104239"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_113151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.6797,
    fill: "white",
    transform: "translate(0 0.160156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipesGreenIcon);
export default __webpack_public_path__ + "static/media/recipes-green-icon.827b39cc6c17633ccac7c2a7f68c84b2.svg";
export { ForwardRef as ReactComponent };